import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as API from "./api";
import * as Actions from "./actions";

function* loadClinicsHandler() {
  try {
    const { response } = yield call(API.loadClinics);
    yield put(Actions.loadClinics.success(response));
  } catch (error) {
    yield put(Actions.loadClinics.failure(error));
  }
}

function* watchLoadClinics() {
  yield takeLatest(Actions.LOAD_CLINICS.REQUEST, loadClinicsHandler);
}

export default function* clinicsSagas() {
  yield all([fork(watchLoadClinics)]);
}
